<template>
  <div class="flex-grow">
    <div
      id="grnhse_app"
      class="min-h-[75vh] w-full [&_iframe]:block [&_iframe]:min-h-[75vh] [&_iframe]:w-full [&_iframe]:border-0" />
  </div>
</template>

<script setup lang="ts">
  import { loadGreenhouseEmbeddedJobApplication } from '~/utils/greenhouse'

  type Props = {
    id: string
  }

  const { id } = defineProps<Props>()
  const route = useRoute()

  const sourceToken = computed(() => (Array.isArray(route.query.gh_src) ? route.query.gh_src[0] : route.query.gh_src))
  const ccuid = computed(() => (Array.isArray(route.query.ccuid) ? route.query.ccuid[0] : route.query.ccuid))

  onMounted(() => {
    renderGreenhouseApplication().catch(console.error)
  })

  watch(
    () => [id, sourceToken.value, ccuid.value],
    () => {
      renderGreenhouseApplication().catch(console.error)
    },
    { flush: 'post' }
  )

  async function renderGreenhouseApplication() {
    await loadGreenhouseEmbeddedJobApplication(id, {
      sourceToken: sourceToken.value || undefined,
      ccuid: ccuid.value || undefined
    })
  }
</script>
